var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaunchingIcon7(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.756,
    height: 121.463,
    viewBox: "0 0 121.756 121.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4469",
    "data-name": "Group 4469",
    transform: "translate(-0.056 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4466",
    "data-name": "Group 4466",
    transform: "translate(0.056 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13635",
    "data-name": "Path 13635",
    d: "M97.513,43.9a4.309,4.309,0,0,0-4.338,0L75.824,55.051a4.346,4.346,0,0,0-2,3.644V52.054A13.018,13.018,0,0,0,60.815,39.04H34.7A13.018,13.018,0,0,0,21.689,52.054V69.4A13.018,13.018,0,0,0,34.7,82.418H60.729A13.018,13.018,0,0,0,73.742,69.4v-6.81a4.35,4.35,0,0,0,2,3.644L93.093,77.386a4.334,4.334,0,0,0,4.42.169,4.341,4.341,0,0,0,2.256-3.813V47.716A4.341,4.341,0,0,0,97.513,43.9M65.066,69.4a4.345,4.345,0,0,1-4.338,4.338H34.7A4.345,4.345,0,0,1,30.364,69.4V52.054A4.345,4.345,0,0,1,34.7,47.716H60.729a4.345,4.345,0,0,1,4.338,4.338Zm26.027-3.592L83.2,60.729l7.895-5.084ZM60.729,0A60.74,60.74,0,0,0,0,60.729a60.035,60.035,0,0,0,16.18,41.122,31.125,31.125,0,0,1-9.2,8.676l-4.863,2.9a4.344,4.344,0,0,0,2.221,8.034H21.689a37.834,37.834,0,0,0,17.351-4.117A60.73,60.73,0,1,0,60.729,0m0,112.782a52.168,52.168,0,0,1-20.348-4.117h-.256a1.815,1.815,0,0,0-.863,0H37.7l-.915.252h-.217a29.528,29.528,0,0,1-14.878,3.865H18.18a38.945,38.945,0,0,0,7.235-9.317v-.308l.612-.829a6.668,6.668,0,0,0,0-.833,6.328,6.328,0,0,0,0-.811,5.861,5.861,0,0,0,0-.781c-.1-.252-.221-.508-.338-.746a3.016,3.016,0,0,0-.525-.694.615.615,0,0,0,0-.252,52.058,52.058,0,1,1,35.565,14.571",
    transform: "translate(0 0)",
    fill: "#dd16c3"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchingIcon7);
export default __webpack_public_path__ + "static/media/launching-icon7.fdebd2e9b843bfe492680fb1dd83e6ab.svg";
export { ForwardRef as ReactComponent };